import React from "react";
import { Line } from "react-chartjs-2";
import "chartjs-plugin-streaming";

// const data = {
//   datasets: [
//     {
//       label: "FloatSat Data",
//       borderColor: "rgb(255, 99, 132)",
//       backgroundColor: "rgba(255, 99, 132, 0.5)",
//       lineTension: 0.5,
//       data: [],
//     },
//   ],
// };

const data = {
  datasets: [
    {
      label: "FloatSat Data",
      borderColor: "rgb(255, 99, 132)",
      backgroundColor: "rgba(255, 99, 132, 0.5)",
      lineTension: 0.5,
      borderDash: [8, 4],
      data: [],
    },
  ],
};

function MainGraph(props) {
  let datatoshow = props.graphdata;
  console.log(datatoshow);

  const options = {
    tooltips: {
      mode: "nearest",
      intersect: false,
    },
    hover: {
      mode: "nearest",
      intersect: false,
    },
    scales: {
      xAxes: [
        {
          type: "realtime",
          realtime: {
            onRefresh: function () {
              data.datasets[0].data.push({
                x: Date.now(),
                y: datatoshow,
              });
            },
            delay: 2000,
          },
        },
      ],
    },
  };

  return (
    <div>
      {/* <Bar data={data} options={options} height={100} /> */}
      <Line data={data} height={100} options={options} />
      {/* {console.log(data)} */}
    </div>
  );
}

export default MainGraph;
